import React from 'react'
import { Card, Button, Space } from 'antd'
import { ChevronDown, ChevronRight, GripVertical } from 'lucide-react'
import { useFFEStore } from '../../store/ffeStore'
import { EditableTitle } from '../Common/EditableTitle'
import { AlternativesTag } from './AlternativesTag'
import type { Group } from '../../types/ffe'
import { GroupSelectionButton } from './GroupSelectionButton'
import { MoreGroupControls } from './MoreGroupControls'

interface Props {
  group: Group
  isCollapsed: boolean
  onToggleCollapse: () => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dragHandleProps: any
}

export const GroupHeader: React.FC<Props> = ({
  group,
  isCollapsed,
  onToggleCollapse,
  dragHandleProps
}) => {
  const updateGroup = useFFEStore((state) => state.updateGroup)

  return (
    <Card
      style={{ border: 'none' }}
      className={`${isCollapsed ? '' : 'mb-4'} bg-gray-50`}
    >
      <div className="flex items-center gap-4">
        <button
          {...dragHandleProps}
          style={{ padding: '1em', margin: '-1em' }}
          className="hidden sm:flex cursor-grab"
        >
          <GripVertical className="h-5 w-5 text-gray-400" />
        </button>

        <Button
          type="text"
          icon={
            isCollapsed ? (
              <ChevronRight className="h-4 w-4" />
            ) : (
              <ChevronDown className="h-4 w-4" />
            )
          }
          onClick={onToggleCollapse}
        />

        <div className="item-title flex-1">
          <EditableTitle
            id={'groupTitle-' + group.id}
            className={'font-semibold'}
            value={group.name}
            onChange={(name) => updateGroup(group.id, { ...group, name })}
            placeholder="Group name"
          />
        </div>

        <Space>{group.isAlternatives && <AlternativesTag />}</Space>

        <div className="flex items-center gap-2">
          <GroupSelectionButton
            groupId={group.id}
            currentGroupId={group.groupId}
          />
          <MoreGroupControls group={group} />
        </div>
      </div>
    </Card>
  )
}
